import { AccessControl } from 'app/business-logic/security/KnownAccessControls';
import { useAppSelector } from 'app/redux/store';
import { useCallback } from 'react';

export const useHasAnyAccess = () => {
  const { accessControls: userAccessControls } = useAppSelector(state => state.profile.user);
  return useCallback(
    (accessControls: AccessControl | AccessControl[]): boolean => {
      if (!accessControls || (Array.isArray(accessControls) && accessControls.length === 0)) return true;

      if (Array.isArray(accessControls)) {
        return accessControls.some(control => userAccessControls[control]);
      }

      return !!userAccessControls[accessControls];
    },
    [userAccessControls]
  );
};
